<template>
  <BaseButton
    class="icon-button"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <BaseIcon :name="icon" class="icon-button__svg" />
  </BaseButton>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'IconButton',
  components: {
    BaseButton,
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    attributes() {
      return {
        view: '',
        ...this.$attrs,
      };
    },
    modifiers() {
      return {
        'icon-button_active': this.isActive,
      };
    },
  },
};
</script>

<style lang="stylus">
.icon-button
  display flex
  align-items center
  justify-content center
  width 2.9em
  height @width
  padding 0.55em
  color $c_primary
  border solid 0.125em $c_border
  border-radius 100%
  &:hover
  &_active
    background-color $c_light

  &__svg
    display block
    width 100%
    height 100%
</style>
